<template>
  <div id="base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'base'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/setup/base/Base.vue